import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import IconButton from "../basic/IconButton";
import ic_close from "../../assets/icons/ic_close.svg";
import LoginDialog from "./LoginDialog";
import CustomDialog from "../basic/Dialog";

function AuthDialog({ open, setOpen }) {
  const [login, setLogin] = useState(true);

  useEffect(() => {
    setLogin(true);
  }, [, open]);

  return (
    <CustomDialog
      show={open}
      close={() => setOpen(false)}
      closeWhenClickedOutside={false}
    >
      <Dialog.Panel
        className={`w-full ${
          login ? "max-w-xl" : "max-w-4xl"
        } transform overflow-hidden rounded-2xl bg-[#0B0F19] p-6 text-left align-middle shadow-xl transition-all`}
      >
        <div className="w-full flex justify-end items-end">
          <IconButton
            icon={ic_close}
            className="shadow-xl flex justify-end"
            onClick={() => setOpen(false)}
          />
        </div>
        <LoginDialog
          closeDialog={() => {
            setOpen(false);
          }}
        />
      </Dialog.Panel>
    </CustomDialog>
  );
}
export default AuthDialog;
